import { Database, Server, User } from "lucide-react";

const ScopeTab = ({ scopeData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">System Scope</h3>
                <p className="text-sm text-slate-500 mt-1">Assets, environments, and data classifications under audit.</p>
              </div>
              <span className="text-xs font-bold bg-indigo-50 text-indigo-700 px-4 py-2 rounded-full ring-1 ring-indigo-200/50">
                {scopeData.length} Systems Active
              </span>
            </div>
            <div className="grid grid-cols-1 gap-4">
              {scopeData.map((scope) => (
                <div key={scope.id} className="bg-white p-5 rounded-2xl ring-1 ring-slate-200/60 shadow-sm hover:ring-indigo-300/60 transition-all flex flex-col md:flex-row items-start md:items-center gap-6">
                  <div className="flex items-center gap-4 w-full md:w-1/3">
                     <div className="p-3 bg-slate-50 text-slate-600 rounded-xl ring-1 ring-slate-200/50"><Server size={22} /></div>
                     <div>
                       <h4 className="text-base font-bold text-slate-900">{scope.system}</h4>
                       <span className={`inline-block mt-1 text-[10px] font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full ring-1 ${scope.environment === 'Production' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200/50' : 'bg-amber-50 text-amber-700 ring-amber-200/50'}`}>
                         {scope.environment}
                       </span>
                     </div>
                  </div>
                  
                  <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                    <div className="bg-slate-50/50 p-3 rounded-xl border border-slate-100 flex flex-col justify-center">
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 flex items-center gap-1.5"><Database size={12} className="text-indigo-400"/> Data Handled</span>
                      <span className="text-sm font-semibold text-slate-800">{scope.data}</span>
                    </div>
                    <div className="bg-slate-50/50 p-3 rounded-xl border border-slate-100 flex flex-col justify-center">
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 flex items-center gap-1.5"><User size={12} className="text-indigo-400"/> System Owner</span>
                      <span className="text-sm font-semibold text-slate-800">{scope.owner}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default ScopeTab;